import React from 'react';
import './styles.css';

type CtaProps = {
  onNavigate: (href: string) => void;
};

function Cta({ onNavigate }: CtaProps) {
  return (
    <section className="cta scroll-reveal">
      <div>
        <h2>Ready to unlock better margins?</h2>
        <p>
          Start with a pilot order this week. We will set up your dedicated
          supply lane in 48 hours.
        </p>
      </div>
      <button
        className="btn"
        type="button"
        onClick={() => {
          onNavigate('/#contact');
        }}
      >
        Book a tasting
      </button>
    </section>
  );
}

export default Cta;
